"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("./typography.style");
var _templateObject;
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const StyledTypography = _styledComponents["default"].h1.withConfig({
  shouldForwardProp: prop => !['fontStyle', 'paragraph', 'div', 'variant', 'fit'].includes(prop)
}).attrs(_ref => {
  let {
    variant
  } = _ref;
  return {
    variant
  };
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"])), _typography.variants.appearances, _typography.variants.fontStyles);
const Typography = _a => {
  var {
      className = 'typography',
      paragraph,
      div
    } = _a,
    rest = __rest(_a, ["className", "paragraph", "div"]);
  const tagType = paragraph ? 'p' : div ? 'div' : rest.variant === 'body1' || rest.variant === 'body2' ? 'span' : rest.variant;
  return (0, _jsxRuntime.jsx)(StyledTypography, (0, _extends2["default"])({
    className: className,
    as: tagType
  }, rest));
};
var _default = exports["default"] = Typography;